import React, { Component } from 'react';
import { InputItem, TextareaItem, ImagePicker, Toast } from 'antd-mobile'
import { Checkbox } from 'antd'
import { req_findRecordById, req_shenpiRecord } from './../../api/api'
import './index.css'
import IP from './../../config/config'
import cookie from 'react-cookies'
import moment from 'moment'

export default class componentName extends Component {
  state = {
    approvalRecord: {
      type_id: '',
      dep_id: '',
      teacher_code: '',
      work_unit: '',
      start_time: '',
      end_time: '',
      description: '',
      visitor_num: 1,
    },
    visitorRecord: [{
      visitor_name: '',
      visitor_phone: '',
      visitor_image: '',
      visitor_url: [],
      checked: false,
    }],
    tabsClick: 0,
    options: [
      { label: '南校区', value: 1 },
      { label: '北校区', value: 2 },
      { label: '医学院校区', value: 3 },
    ]
  }

  componentDidMount = () => {
    this.fetch(this.props.match.params.id)
  }


  fetch = async (recordId) => {
    const { options } = this.state
    const res = await req_findRecordById({ recordId })
    if (res.code === 20000) {
      res.data.start_time = moment(res.data.start_time).format('YYYY-MM-DD HH:mm')
      res.data.end_time = moment(res.data.end_time).format('YYYY-MM-DD HH:mm')
      const visitorRecord = res.data.visitorRecordEntities.map(val => {
        const item = {
          visitor_image: val.visitor_image,
          visitor_name: val.visitor_name,
          visitor_phone: val.visitor_phone,
          visitor_url: [{
            url: IP.host + val.visitor_image
          }],
          checked: false
        }
        return item
      })
      if (res.data.status == 1) {
        res.data.status_name = '待审核'
      } else if (res.data.status == 2) {
        res.data.status_name = '审核通过'
      } else if (res.data.status == 3) {
        res.data.status_name = '审核不通过'
      } else {
        res.data.status_name = '已失效'
      }
      let school_campus = ''
      res.data.school_campus.split(',').map(val => {
        school_campus += options.find(x => x.value == val).label + ' '
        return options.find(x => x.value == val)
      })
      res.data.school_campus = school_campus
      this.setState({
        approvalRecord: res.data,
        visitorRecord
      })
    }
  }

  // 审核
  audit = async (status) => {
    const { visitorRecord } = this.state
    if (status === 2) {
      if (visitorRecord.length !== visitorRecord.filter(x => x.checked === true).length) {
        Toast.offline("请确认所有来客信息是否符合要求！")
        return false;
      }
    }
    Toast.loading("正在审核中...", 0)
    const params = {
      recordId: this.props.match.params.id,
      status
    }
    const res = await req_shenpiRecord(params)
    if (res.code === 20000) {
      Toast.hide()
      this.fetch(this.props.match.params.id)
      Toast.success(res.message)
    }
  }


  render() {
    const { approvalRecord, visitorRecord, tabsClick } = this.state
    return (
      <div className="register">
        <div className="register-top">
          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              value={approvalRecord.school_campus}
            >访问校区</InputItem>
          </div>
          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              value={approvalRecord.type_name}
            >探访类型</InputItem>
          </div>


          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              value={approvalRecord.dep_name}
            >探访部门</InputItem>
          </div>
          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              value={approvalRecord.teacher_name}
            >探访人</InputItem>
          </div>
          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              value={approvalRecord.teacher_phone}
            >探访人电话</InputItem>
          </div>
        </div>

        <div className="register-main">
          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              value={approvalRecord.work_unit}
            >来访单位</InputItem>
          </div>

          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              value={approvalRecord.start_time}
            >探访开始时间</InputItem>
          </div>

          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              value={approvalRecord.end_time}
            >探访结束时间</InputItem>
          </div>
          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              value={approvalRecord.status_name}
            >审核状态</InputItem>
          </div>
          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              value={approvalRecord.plate_no}
            >车牌号</InputItem>
          </div>
          {/* <div className="item-input">
            <InputItem
              type='number'
              placeholder="请输入来客数量"
              value={approvalRecord.visitor_num}
              onChange={(val)=>{
                if(val==='' || val === '0'){
                  val=1
                }
                // 计算数量是增加还是减少了
                if(approvalRecord.visitor_num<val){
                  const maxNnum = val-approvalRecord.visitor_num
                  const first = {
                      visitor_name: '',
                      visitor_phone: '',
                      visitor_image: ''
                    }
                  for(var i=0;i<maxNnum;i++){
                    visitorRecord.push(first)
                  }
                }else{
                  const minNnum = approvalRecord.visitor_num-val
                  for(var i=0;i<minNnum;i++){
                    visitorRecord.pop()
                  }
                }
                approvalRecord.visitor_num=val
                this.setState({
                  approvalRecord,
                  visitorRecord
                })
              }}
            >来客数量</InputItem>
          </div> */}
          <div className="item-text">
            <div className="item-text-title">探访事由</div>
            <TextareaItem
              placeholder="请输入探访事由"
              rows={5}
              value={approvalRecord.description}
            />
          </div>

        </div>
        <div className="register-foot" style={{ paddingBottom: approvalRecord.status == 1 ? '140px' : '16px' }}>
          <div className="register-tabs">
            <div className="register-tabs-scroll">
              <div className="register-tabs-width">
                {
                  visitorRecord.map((val, key) => {
                    return (<div className={tabsClick === key ? 'register-tabs-click' : ''} key={key} onClick={() => {
                      this.setState({
                        tabsClick: key
                      })
                    }}>来客{key + 1}</div>)
                  })
                }
              </div>
            </div>
          </div>
          <div style={{ padding: '10px 16px 0px' }}>
            <Checkbox checked={visitorRecord[tabsClick].checked} onChange={(item) => {
              visitorRecord[tabsClick].checked = item.target.checked
              this.setState({
                visitorRecord
              })
            }}>已确认来客信息符合要求</Checkbox>
          </div>
          <div className="item-input">
            <InputItem
              placeholder="请输入来客姓名"
              value={visitorRecord[tabsClick].visitor_name}
            >来客姓名</InputItem>
          </div>
          <div className="item-input">
            <InputItem
              type='phone'
              placeholder="请输入手机号"
              value={visitorRecord[tabsClick].visitor_phone}
            >手机号</InputItem>
          </div>
          <div className="item-upload">
            <div className="item-upload-title" style={{ marginTop: '6px' }}>照片</div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ width: '100px', flex: '1 1' }}>
                <ImagePicker
                  selectable={false}
                  capture="camera"
                  disableDelete={true}
                  className="register_image"
                  length={1}
                  files={visitorRecord[tabsClick].visitor_url}
                />
              </div>
              <div>
                <img src={require('./../../images/example.jpg')} style={{ width: '90%' }} alt='' />
              </div>
            </div>
          </div>
        </div>
        {
          (cookie.load('teacher_code') == approvalRecord.teacher_code && approvalRecord.status == 1) ? (<div className="details-but">
            <div onClick={() => {
              this.audit(3)
            }}>不通过</div>
            <div onClick={() => {
              this.audit(2)
            }}>通过</div>
          </div>) : ('')
        }
      </div>
    );
  }
}
